import Recaptcha from './js/Recaptcha';

export default Recaptcha;
